import React, { Component } from 'react';
import './App.css';
import { Loader } from 'components';
import { withRouter } from 'react-router-dom';
import { renderRoutes, routes } from 'routing';
import { inject, observer } from 'mobx-react';

@withRouter
@inject(rootStore => ({
	authStore: rootStore.authStore,
	appStore: rootStore.appStore
}))
@observer
class App extends Component {

	async componentDidMount() {
		const { appStore, authStore } = this.props;
		await authStore.initialize();
		appStore.setInitialized();
	}

	render() {
		const { initializing } = this.props.appStore;
		if (initializing) {
            return (
                <Loader />
            );
        }

		return renderRoutes(routes);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js